import { ReactionActionButton } from './ReactionActionButton';
import { ReactionsOnMessageContainer } from './ReactionsOnMessageContainer';
import { observer } from 'mobx-react-lite';
import { ClientItemId } from 'owa-client-ids';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-mail-store';
import * as React from 'react';
import Message from 'owa-service/lib/contract/Message';

const styles = require('./ReactionsContainer.scss');

export interface ReactionsContainerProps {
    conversationId: ClientItemId;
    itemId: ClientItemId;
    item: ClientItem;
    instrumentationContext: InstrumentationContext;
    isConversationView: boolean;
}

export const ReactionsContainer = observer(function ReactionsContainer(
    props: ReactionsContainerProps
) {
    const containerStyle = props.isConversationView
        ? styles.reactionsContainerBottomRP
        : styles.reactionsContainerBarItemHeader;

    const message = props.item as Message;
    if (!message.Reactions && !props.isConversationView) {
        return null;
    }

    return (
        <div className={containerStyle}>
            <ReactionsOnMessageContainer
                message={message}
                conversationId={props.conversationId}
                itemId={props.itemId}
                instrumentationContext={props.instrumentationContext}
            />

            {props.isConversationView && (
                <ReactionActionButton
                    conversationId={props.conversationId}
                    itemId={props.itemId}
                    item={props.item}
                    instrumentationContext={props.instrumentationContext}
                    isConversationView={true}
                />
            )}
        </div>
    );
});
